import React from "react";
import { Provider } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import { compose } from "recompose";
import injectUser from "../../HoC/injectUser";

class Header extends React.Component {
    state = {
        mobile_toggled: false,
        hide: true
    }
    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll);
    }
    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }
    mobileToggle = () => {
        let val = !this.state.mobile_toggled
        return () => this.setState(prevState => {
            console.log(555)
            prevState.mobile_toggled = val
            return prevState;
        })
    }
    hideToggle = () => {
        let val = !this.state.hide
        return () => this.setState(prevState => {
            console.log(555)
            prevState.hide = val
            return prevState;
        })
    }
    handleScroll = e => {
        if (window.scrollY){
            if (!this.state.header_on_move) this.setState({
                header_on_move: true
            })
        } else {
            if (this.state.header_on_move) this.setState({
                header_on_move: false
            })
        }
    }
    render(){
        let { header_on_move } = this.state;
        let { current_user } = this.props;
        if (!current_user) return null;
        let logged_in_user = !current_user.isGuest
        return (
            <React.Fragment>
                <header className={header_on_move ? "header-on-move" : ""}>
                    <div className="header-container row">
                    <Link to="/" className="logo"><img src="../assets/toolkit/images/logo2.svg" alt="" /></Link>
                    <ul className="header__links">
                        <li className="active hl__li">
                            <Link to="/">Home</Link>
                        </li>
                        <li className="hl__li"><Link to="/floors">Showroom</Link>
                            <ul className="sub-menu">
                                <Link to="/floors"><li>Luxury Vinyl Plank</li></Link>
                                <Link to="/floors"><li>Tile</li></Link>
                                <Link to="/floors"><li>Bamboo</li></Link>
                                <Link to="/floors"><li>Solid Hardwood</li></Link>
                                <Link to="/floors"><li>Exotics</li></Link>
                                <Link to="/floors"><li>Future</li></Link>
                            </ul>
                        </li>
                        <li className="hl__li"><Link to="/about-us">Why us?</Link>
                            {/* <ul className="sub-menu">
                                <li>Our Filosophy</li>
                                <li>The Chronicles</li>
                                <li>Our constitution</li>
                                <li>Solyd ipseity</li>
                            </ul> */}
                        </li>

                        <li className="hl__li"><Link to="/contact-us">Connect</Link>
                            {/* <ul className="sub-menu">
                                <li>Contact us</li>
                                <li>Collaborations</li>
                                <li>Endorsements</li>
                                <li>Trade Memberships</li>
                            </ul> */}
                        </li>

                        <li className="hl__li"><Link to="/coming-soon"><img src="../../assets/toolkit/images/solyd-light2.svg" alt="" /></Link></li>
                    </ul>
                    <div className="header__registration">
                        <div className={`header__profile--dropdown ${this.state.hide ? "hide": ""}`}>
                            <ul>
                                <li onClick={() => this.props.history.push("/my_profile")}>My Profile</li>
                                <li onClick={() => this.props.history.push("/my_orders")}>My Orders</li>
                                <li onClick={() => this.props.history.push("/invoices")}>Invoices</li>
                                <li onClick={() => this.props.history.push("/logout")} style={{color: '#ff7979'}}>Logout</li>
                                <li>
                                    <div className="hpd__socials">
                                    <a href="#"><img src="../../assets/toolkit/images/instagram.svg" /></a>
                                    <a href="#"><img src="../../assets/toolkit/images/instagram.svg" /></a>
                                    <a href="#"><img src="../../assets/toolkit/images/instagram.svg" /></a>
                                    <a href="#"><img src="../../assets/toolkit/images/instagram.svg" /></a>
                                    </div>
                                </li>
                            </ul>
                        </div>

                        {
                            !logged_in_user ?
                            <ul className="mb0">
                                <li><Link to="/login">Login</Link></li>
                                <li><Link to="/register">Register</Link></li>
                                <Link to="/my_cart">
                                    <li
                                        style={{ width: 50 }}
                                    ><img src="../../assets/toolkit/images/cart.svg" alt="" /></li>
                                </Link>
                            </ul>
                            :
                            <ul className="mb0">
                                <Link to="/my_cart">
                                    <li><img src="../../assets/toolkit/images/cart.svg" alt="" /></li>
                                </Link>
                                
                                <li
                                    style={{ cursor: "pointer" }}
                                    onClick={this.hideToggle()}
                                ><div className="menu-profile"><img src="../../assets/toolkit/images/person2.svg" alt="" /></div></li>
                                
                            </ul>
                        }
                        <div className="header__mobile-menu">
                        <div className="menu-btn" onClick={this.mobileToggle()}>
                            <div className="menu-btn__burger" />
                        </div>
                        </div>
                    </div>
                    </div>
                </header>
                <div class="row relative">
                    <div class={`header__mobile-toggle ${this.state.mobile_toggled ? "toggle" : ""}`}>
                        <ul class="header__links">
                            <li class="active"><Link to="/">Home</Link></li>
                            <li><Link to="/floors">Browse</Link></li>
                            <li ><Link to="/about-us">About</Link></li>
                            <li><Link to="/contact-us">Contact</Link></li>
                            <li><Link to="/home-learn">Learn</Link></li>
                            {
                                !logged_in_user ?
                                    <React.Fragment>
                                        <li><Link to="/login" class="yellow-text">Login</Link></li>
                                        <li><Link to="/register" class="yellow-text">Register</Link></li>
                                    </React.Fragment>
                                : <React.Fragment>
                                        <li><Link to="/logout" class="yellow-text">Logout</Link></li>
                                </React.Fragment>
                            }
                        </ul>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}

export default compose(injectUser,withRouter)(Header);